import React from 'react';
import ReactDOM from 'react-dom';
import SearchButton from './SearchButton/SearchButton';
import SearchForm from './SearchForm/SearchForm';

let element = document.getElementById('react-search-modal');
if (element && typeof(element) !== 'undefined') {
  ReactDOM.render(<SearchButton index={ element.getAttribute('data-index') } />, element);
}

element = document.getElementById('react-search-form');
if (element && typeof(element) !== 'undefined') {
  ReactDOM.render(<SearchForm index={ element.getAttribute('data-index') } />, element);
}
